import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import NavPills from '../../components/NavPills/NavPills';
import useDocumentTitle from '../../hooks/useDocumentTitle';

// Import the content components
import TourPage from './Tour/TourPage';
import { GuidesPage } from './GuidePage/GuidesPage';
import { RulesetsPage } from './RulesetsPage/RulesetsPage';
import LivestreamPage from './LivestreamPage/LivestreamPage';
import { RequireAuth } from 'components/Auth/RequireAuth';
import styles from '../../assets/jss/material-kit-react/views/profilePage';
import BubbleContainer from 'components/BubbleContainer/BubbleContainer';

const useStyles = makeStyles<Theme>((theme) => ({
  mainContainer: {
    position: 'relative',
    zIndex: 2,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '6px',
    color: theme.palette.text.primary,
  },
  container: {
    ...styles.container,
    position: 'relative',
    zIndex: 3,
  },
  contentContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    zIndex: 1100,
    '& .MuiTabs-root': {
      zIndex: 1200,
    },
    '& .MuiTab-root': {
      zIndex: 1200,
    },
  },
  pillContent: {
    padding: '20px 0',
  },
}));

export default function CombinedTourPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  useDocumentTitle(t('navigation.tour'));

  return (
    <RequireAuth requiredPermission="is_staff">
      <div>
        <div className={classes.mainContainer}>
          <div className={classes.container}>
            <div className={classes.contentContainer}>
              <NavPills
                queryKey={'section'}
                alignCenter
                fullWidth
                onChange={function () {}}
                color="primary"
                tabs={[
                  {
                    tabName: t('navigation.tour'),
                    tabButton: t('navigation.tour'),
                    tabContent: <TourPage />,
                  },
                  {
                    tabName: t('navigation.rulesets'),
                    tabButton: t('navigation.rulesets'),
                    tabContent: <RulesetsPage />,
                  },
                  {
                    tabName: t('navigation.livestream'),
                    tabButton: t('navigation.livestream'),
                    tabContent: <LivestreamPage />,
                  },
                  {
                    tabName: t('navigation.guides'),
                    tabButton: t('navigation.guides'),
                    tabContent: <GuidesPage />,
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <BubbleContainer pageKey="tour" helpText={t('help.tour')} />
      </div>
    </RequireAuth>
  );
}
